import { useEffect, useState } from "react";
import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND}/api`;

export function useSiteImages() {
  const [images, setImages] = useState({ hero: null, about: null, practice: null });
  useEffect(() => {
    axios
      .get(`${API}/site-images`)
      .then(({ data }) => {
        const url = (p) => (p ? `${BACKEND}/api/files/${p}` : null);
        setImages({ hero: url(data.hero), about: url(data.about), practice: url(data.practice) });
      })
      .catch(() => {});
  }, []);
  return images;
}
